import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Store, ArrowRight } from "lucide-react";
import { Card, CardContent } from "../ui/card";
import { Badge } from "../ui/badge";
import { Button } from "../ui/button";
import { api } from "../../lib/api";
import { nok, productUrl, shopUrl } from "../../lib/shop";
import { ProductImage } from "./ProductCard";
import { useLang } from "../../context/LanguageContext";

// «Butikken vår» – vist på arrangements- og arrangørsida berre når arrangøren har open butikk med aktive varer (fail-soft).
export const ShopTeaser = ({ organizerId, organizerName, className = "" }) => {
  const { t } = useLang();
  const [teaser, setTeaser] = useState(null);
  useEffect(() => {
    if (!organizerId) return;
    let alive = true;
    api.get(`/shop/organizers/${organizerId}/teaser`).then((res) => alive && setTeaser(res.data)).catch(() => alive && setTeaser(null));
    return () => {
      alive = false;
    };
  }, [organizerId]);
  if (!teaser?.enabled || !teaser.products?.length) return null;
  return (
    <Card className={`border-border bg-card ${className}`} data-testid="shop-teaser">
      <CardContent className="p-5 space-y-4">
        <div className="flex items-start justify-between gap-3">
          <div className="flex items-center gap-2 min-w-0">
            <span className="inline-flex items-center justify-center w-9 h-9 rounded-xl bg-[hsl(var(--brand-soft))] text-[hsl(var(--brand))] shrink-0"><Store className="w-5 h-5" /></span>
            <div className="min-w-0">
              <p className="font-heading font-semibold">{t("Butikken vår")}</p>
              <p className="text-xs text-muted-foreground truncate">{organizerName}</p>
            </div>
          </div>
          <Badge variant="outline" className="shrink-0" data-testid="shop-teaser-count">{teaser.product_count === 1 ? t("{n} vare", { n: 1 }) : t("{n} varer", { n: teaser.product_count })}</Badge>
        </div>
        <div className="grid grid-cols-3 gap-2">
          {teaser.products.map((p) => (
            <Link key={p.id} to={productUrl(organizerId, p.id)} className="group block min-w-0" data-testid={`shop-teaser-product-${p.id}`}>
              <div className="aspect-[4/3] rounded-lg overflow-hidden bg-muted">
                <ProductImage product={p} />
              </div>
              <p className="text-xs mt-1.5 line-clamp-1 group-hover:underline underline-offset-2">{p.name}</p>
              <p className="text-xs font-semibold tabular-nums">{p.price === 0 ? t("Gratis") : nok(p.price)}</p>
            </Link>
          ))}
        </div>
        <Button asChild variant="secondary" className="w-full justify-center" data-testid="shop-teaser-link">
          <Link to={shopUrl(organizerId)}>
            {t("Se butikken")} <ArrowRight className="w-4 h-4 ml-1.5" />
          </Link>
        </Button>
      </CardContent>
    </Card>
  );
};
